import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import produce from 'immer';
import { appAPI } from 'api/appAPI';

export const fetchLastRefreshDate = createAsyncThunk(
    'app/fetchLastRefreshDate',
    async () => {
        return await appAPI.fetchLastRefreshDate();
    }
);

export const fetchSettings = createAsyncThunk('app/fetchSettings', async () => {
    return await appAPI.fetchSettings();
});

export const validateUser = createAsyncThunk(
    'app/validateUser',
    async (user) => {
        const username = 'SRSuser123';
        const password = 'P9ASpoPRagi63-+hl4eS';
        if (user.username === username && user.password === password) {
            return await Promise.resolve({
                isAuthenticated: true,
                user: {
                    name: 'John Doe'
                }
            });
        } else {
            return await Promise.reject({
                isAuthenticated: false,
                user: null
            });
        }
    }
);

const initialState = {
    showRmInvestigationOverlay: false,
    showOverallAppOverlay: false,
    showUserProfileOverlay: false,
    lastRefreshDate: null,
    settings: null,
    user: null,
    isAuthenticated: null
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        toggleOverallAppOverlay: (state) =>
            produce(state, (draft) => {
                draft.showOverallAppOverlay = !state.showOverallAppOverlay;
            }),
        toggleRmInvestigationOverlay: (state) =>
            produce(state, (draft) => {
                draft.showRmInvestigationOverlay =
                    !state.showRmInvestigationOverlay;
            }),
        showUserProfileOverlay: (state) =>
            produce(state, (draft) => {
                draft.showUserProfileOverlay = true;
            }),
        hideUserProfileOverlay: (state) =>
            produce(state, (draft) => {
                draft.showUserProfileOverlay = false;
            }),
        logout: (state) =>
            produce(state, (draft) => {
                draft.user = null;
                draft.isAuthenticated = null;
            })
    },
    extraReducers: (builder) => {
        builder.addCase(fetchLastRefreshDate.fulfilled, (state, { payload }) =>
            produce(state, (draft) => {
                draft.lastRefreshDate = payload.lastRefreshDate;
            })
        );
        builder.addCase(fetchSettings.fulfilled, (state, { payload }) =>
            produce(state, (draft) => {
                const { thresholdSettings } = payload;
                draft.settings = thresholdSettings;
            })
        );

        builder.addCase(validateUser.fulfilled, (state, { payload }) => {
            return produce(state, (draft) => {
                draft.user = payload.user;
                draft.isAuthenticated = payload.isAuthenticated;
            });
        });
        builder.addCase(validateUser.rejected, (state) => {
            return produce(state, (draft) => {
                draft.user = null;
                draft.isAuthenticated = false;
            });
        });
    }
});

const { actions, reducer: appReducer } = appSlice;

export const {
    toggleOverallAppOverlay,
    toggleRmInvestigationOverlay,
    hideUserProfileOverlay,
    showUserProfileOverlay,
    logout
} = actions;
export default appReducer;
